module.exports = __webpack_public_path__ + "img/ic_64_power.244a022a.svg";